import {useTheme, css, Typography} from '@mui/material';
import {DlMuiPopper, GetStylesFunction, useMuiAnchor} from '@wallaby-ui/core';
import {ICellRendererParams} from 'ag-grid-community';
import * as React from 'react';

type Props = ICellRendererParams & {
  progressPercent: number;
  background?: string;
  tooltipOverride?: string | number | JSX.Element;
  style?: React.CSSProperties;
  bold?: boolean;
  centerText?: boolean;
  paddingLeft?: number;
};

export const ProgressBarFormatter: React.FC<Props> = (props) => {
  const {value, tooltipOverride, style, bold, progressPercent, background = 'var(--dlTheme-300)', centerText, paddingLeft} = props;

  const tooltip = tooltipOverride ?? value;
  const hasTooltip = tooltip != null && tooltip !== '';
  const theme = useTheme();
  const styles = getStyles({theme, params: {paddingLeft}});

  const {mouseEventEnter, mouseEventLeave, open, anchorEl} = useMuiAnchor(hasTooltip);

  return (
    <Typography display='block' variant={bold ? 'valueBold' : 'value'} style={style}>
      <div css={styles.wrapper} onMouseEnter={mouseEventEnter} onMouseLeave={mouseEventLeave}>
        <div css={styles.progressBar} style={{background, width: `${progressPercent}%`}} />
        <span
          css={styles.span}
          style={
            centerText
              ? {
                  paddingLeft: 0,
                  textAlign: 'center',
                }
              : undefined
          }
        >
          {value}
        </span>
      </div>
      <DlMuiPopper hasTooltip={hasTooltip} anchorEl={anchorEl} open={open}>
        <Typography variant={'popper'}>{String(tooltip)}</Typography>
      </DlMuiPopper>
    </Typography>
  );
};
ProgressBarFormatter.displayName = 'ProgressBarFormatter';

const getStyles: GetStylesFunction = (options) => ({
  wrapper: css`
    width: 100%;
    height: 26px;
    position: relative;
  `,
  progressBar: css`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 4px;
  `,
  span: css`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding: 4px 0 4px ${options?.params?.paddingLeft ?? 14}px;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  `,
});
